<template>
  <el-dialog :visible.sync="formVisible" :close-on-click-modal="false" width="560px" class="approve-dialog" top="10vh"
    @close="handleClose">
    <div slot="title" class="dialog-title">
      <img src="../../../assets/icon-green.png" alt="approve" class="title-icon" />
      <div class="title-content">
        <div class="title-main">同意申请</div>
        <div class="title-sub">同意申请后充值额度才会到账</div>
      </div>
    </div>
    <div class="dialog-body">
      <div class="detail-box" v-if="currentRow">
        <div class="detail-item">
          <span class="label">用户信息：</span>
          <span class="value">{{ formatUserInfo(currentRow) }}</span>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="label">充值账户：</span>
            <span class="value">{{ currentRow.userMainId == 0 ? '主账户' : '子账户' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">入账账户：</span>
            <span class="value">{{ 
            currentRow.userMainId>0?( currentRow.auditStatus===10?(currentRow.customerTypeWalletCredit===1?'主账户':'子账户'):
            (currentRow.isUseParentWallet === 1 ? '主账户' : '子账户') ):'主账号'
            }}</span>
          </div>
        </div>
        <div class="detail-row">
          <div class="detail-item">
            <span class="label">充值金额：</span>
            <span class="value">{{ formatAmount(currentRow.orderAmount) }}</span>
          </div>
          <div class="detail-item">
            <span class="label">充值类型：</span>
            <span class="value">{{ currentRow.rechargeType || '-' }}</span>
          </div>
        </div>
        <div class="detail-item">
          <span class="label">赠送活动：</span>
          <span v-if="currentRow.giveType === 1">{{currentRow.xiaoduMoney}}零售价</span>
            <span v-else-if="currentRow.giveType === 2">{{ currentRow.goodsName }}*1件</span>
            <span v-else>-</span>
          <!-- <span class="value">{{ currentRow.giftActivity || '-' }}</span> -->
        </div>
        <div class="detail-item">
          <span class="label">申请原因：</span>
          <span class="value">{{ currentRow.orderNote || '-' }}</span>
        </div>
      </div>
      <div class="voucher-list" v-if="getVoucherList(currentRow).length > 0">
        <div v-for="(item, idx) in getVoucherList(currentRow)" :key="idx" class="voucher-item">
          <span class="label">凭证：</span>
          <el-image v-if="item.payImg || item.imgUrl" class="voucher-img"
            style="width: 60px; height: 60px; flex-shrink: 0;" :src="item.payImg || item.imgUrl"
            :preview-src-list="[item.payImg || item.imgUrl]" />
          <div class="voucher-detail">
            <div>收款银行：{{ item.receivingBank || item.payBank || '-' }}</div>
            <div>付款方式：{{ currentRow.payMethod === 1 ? '扫码支付' : currentRow.payMethod === 2 ? '银行转账' : '-' }}</div>
            <div class="voucher-row">
              <div class="voucher-row-cell">支付单号：{{ item.payOrderNum || item.payNum || item.paymentOrderNo || '-' }}</div>
              <div class="voucher-row-cell">付款金额：{{ formatAmount(item.payMoney || item.paymentAmount) }}</div>
            </div>
            <div>付款时间：{{ item.payTime || item.paymentTime || '-' }}</div>
          </div>
        </div>
      </div>
      <div class="applicant-info" v-if="currentRow">
        <div class="detail-item">
          <span class="label">申请人：</span>
          <span class="value">{{ formatApplicantInfo(currentRow) }}</span>
        </div>
        <div class="detail-item">
          <span class="label">提交时间：</span>
          <span class="value">{{ currentRow.createdTime || '-' }}</span>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">取消</el-button>
      <el-button type="primary" @click="doApprove" :loading="isLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      formVisible: false,
      isLoading: false,
      currentRow: null
    }
  },
  methods: {
    handleCreate(row) {
      this.currentRow = row
      this.formVisible = true
    },
    handleClose() {
      this.currentRow = null
    },
    formatUserInfo(row) {
      if (!row) return '-'
      if (row.userRealName && row.userLevelName && row.userMobile) {
        return `${row.userRealName}-${row.userLevelName}-${row.userMobile}`
      }
      return '-'
    },
    formatApplicantInfo(row) {
      if (!row) return '-'
      if (row.createdByRealName && row.createdByRoleNames && row.createdByMobile) {
        return `${row.createdByRealName}-${row.createdByRoleNames}-${row.createdByMobile}`
      }
      return row.createdByRealName || '-'
    },
    formatAmount(val) {
      if (val === null || val === undefined || val === '') return '-'
      const num = Number(val)
      return isNaN(num) ? val : num + '元'
    },
    getVoucherList(row) {
      if (!row) return []
      if (row.voucherList && Array.isArray(row.voucherList) && row.voucherList.length > 0) {
        return row.voucherList
      }
      if (row.payVouchersList && Array.isArray(row.payVouchersList) && row.payVouchersList.length > 0) {
        return row.payVouchersList
      }
      return []
    },
    doApprove() {
      if (!this.currentRow || !this.currentRow.id) {
        this.$message.error('数据异常')
        return
      }
      this.isLoading = true
      this.$emit('approve', { id: this.currentRow.id }, () => {
        this.isLoading = false
        this.formVisible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.approve-dialog ::v-deep .el-dialog__header {
  padding: 20px 20px 10px;
}

.approve-dialog ::v-deep .el-dialog__body {
  padding: 10px 20px 20px;
}

.dialog-title {
  display: flex;
  gap: 20px;
  align-items: center;

  .title-icon {
    width: 60px;
  }

  .title-content {
    .title-main {
      font-size: 18px;
      color: #000000;
    }

    .title-sub {
      font-size: 14px;
      color: #8f8e8e;
      padding-top: 10px;
    }
  }
}

.detail-box {
  background: #F8F8F8;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .detail-row {
    display: flex;
    flex-wrap: wrap;
    gap: 24px 40px;

    .detail-item {
      flex: 1;
    }
  }

  .detail-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    font-size: 16px;

    .label {
      color: #666666;
      min-width: 90px;
      flex-shrink: 0;
    }

    .value {
      color: #6c6c6c;
    }
  }
}

.voucher-list {
  background: #F8F8F8;
  padding: 20px;
  border-radius: 4px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 20px;

  .voucher-item {
    display: flex;
    font-size: 14px;
    color: #6C6C6C;
    line-height: 14px;
    align-items: flex-start;

    .label {
      min-width: 80px;
      flex-shrink: 0;
      text-align: right;
    }
  }

  .voucher-img {
    margin-right: 12px;
    border-radius: 4px;
  }

  .voucher-detail {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .voucher-row {
      display: flex;

      .voucher-row-cell {
        flex: 1;
      }
    }
  }
}

.applicant-info {
  display: flex;
  padding: 20px;
  flex-direction: column;
  gap: 20px;
  font-size: 16px;
  color: #666666;

  .detail-item {
    display: flex;
    align-items: center;
    gap: 10px;

    .label,
    .value {
      color: #666666;
    }
  }
}
</style>
